var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-arrow-down',
                        view: publicPath + 'sprite.svg#view-icon-arrow-down',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/arrow-down',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };